import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize',
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    // Convert to lowercase first, then capitalize first letter
    const lowercased = value.toLowerCase();
    return lowercased.charAt(0).toUpperCase() + lowercased.slice(1);
  }
}
